import { BasketItem, basketItemFactory } from '@df/session/api/basket/basket-item';
import { LocalProduct } from '../../catalog/model/product/product.decorator';
import { IProductDataV3 } from '@df/catalog/product/product';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketItem {
            isReward?: boolean;
            reward_points?: number;
            rewardId?: string;
            errors?: string[];
            am_giftcard_image_url?: string;
        }
    }
}

export class LocalBasketItem extends BasketItem<LocalProduct<IProductDataV3>> {
    get warning(): string | undefined {
        const beErrors = this.data.errors;
        if (beErrors?.length) {
            return beErrors[0];
        }
        if (!this.isSalable()) {
            return 'Out of stock';
        }
        if (this.maxQty < 6) {
            return 'Limited stock';
        }
        return undefined;
    }
    get giftCardPersonalisedMessage(): string {
        return this.data?.request?.am_giftcard_message || '';
    }
    get isGiftcard(): boolean {
        return !!this.product?.giftCard?.isGiftcard;
    }
    get isVirtual(): boolean {
        return !!this.data?.virtual;
    }
    get isFree(): boolean {
        return !!(this.data.rowPrice === 0);
    }

    get isFreeGift(): boolean {
        return this.data?.request?.options?.ampromo_rule_id && this.isFree;
    }

    get productCanBeRemoved(): boolean {
        return (
            (this.isFree && this.data.errors && this.data.errors.length > 0) ||
            (this.isFree && !this.isSalable()) ||
            (!this.isFree && !this.isVirtual) ||
            this.isGiftcard ||
            this.isReward
        );
    }

    get isReward(): boolean {
        return !!this.data.isReward;
    }

    get rewardPoints(): number | undefined {
        return this.data.reward_points && this.data.reward_points * this.data.request.qty;
    }

    get rewardId(): string | undefined {
        return this.data.rewardId;
    }
}
basketItemFactory.instance = LocalBasketItem;
